import { EpimsBaseEntityDto } from './epim-base.dto';
export class AdrAssetsDto extends EpimsBaseEntityDto {
    
    AdrAssetId:string;
    AdrId:string;
    SuitNo:string;
    NewLandId:string;
    LandName:string;
    StateName:string;
    LgaName:string;
    CommunityName:string;
    Remarks:string;
    SubscriptionUserId:string;
    SubscriberId:string;
    

}